import { render } from "./ctx-dog-objs.vue?vue&type=template&id=61b3315b&scoped=true"
import script from "./ctx-dog-objs.vue?vue&type=script&setup=true&lang=js"
export * from "./ctx-dog-objs.vue?vue&type=script&setup=true&lang=js"

import "./ctx-dog-objs.vue?vue&type=style&index=0&id=61b3315b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b3315b"],['__file',"src/views/history/history-card/components/ctx-dog-objs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61b3315b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61b3315b', __exports__)) {
    api.reload('61b3315b', __exports__)
  }
  
  module.hot.accept("./ctx-dog-objs.vue?vue&type=template&id=61b3315b&scoped=true", () => {
    api.rerender('61b3315b', render)
  })

}


export default __exports__